import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FontFamily,
  FontWeight,
  Icon,
  IconNames,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

import type { RecipeSubtitleItem } from './getRecipeSubtitleItems'

type RecipeSubtitleItemsProps = {
  items: RecipeSubtitleItem[]
}

const iconTypeToIconName: Record<NonNullable<RecipeSubtitleItem['iconType']>, IconNames> = {
  rating: 'rate_full',
  spice: 'chilli',
  r2hTime: 'microwave',
}

const renderIcon = (item: RecipeSubtitleItem) => {
  if (!item.iconType) {
    return null
  }

  return (
    <Icon
      aria-hidden="true"
      name={iconTypeToIconName[item.iconType]}
      size={4}
      variant={IconVariant.Inherit}
    />
  )
}

export const RecipeSubtitleItems = ({ items }: RecipeSubtitleItemsProps) => (
  <Box display={Display.Flex} alignItems={AlignItems.Center} gap={1} wrap>
    {items.map((item, index) => (
      <React.Fragment key={`${item.type}-${item.text}`}>
        {index > 0 ? (
          <Text
            size={2}
            fontFamily={FontFamily.Book}
            fontWeight={FontWeight.Normal}
            color={Color.ColdGrey_600}
          >
            •
          </Text>
        ) : null}
        <Box
          color={Color.ColdGrey_600}
          display={Display.Flex}
          alignItems={AlignItems.Center}
          gap={1}
        >
          {renderIcon(item)}
          <Text
            size={2}
            fontFamily={FontFamily.Book}
            fontWeight={FontWeight.Normal}
            color={Color.Inherit}
          >
            {item.text}
          </Text>
        </Box>
      </React.Fragment>
    ))}
  </Box>
)
